/**
 * Keep these in sync with Tailwind's configured breakpoints.
 *
 * Uses 970px so "Request desktop site" on mobile (browsers often use 970px viewport)
 * shows the desktop layout. See `tailwind.config.js` and index.html critical CSS.
 */
export const TAILWIND_MD_MIN_PX = 970;
export const TAILWIND_MD_MAX_PX = TAILWIND_MD_MIN_PX - 1;

/** Matches `tailwind.config.js` screens.lg */
export const TAILWIND_LG_MIN_PX = 1280;

